// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__9Pnzc","main":"SecTwo_main__eZ7-A","text":"SecTwo_text__xrQub","types":"SecTwo_types__UC6a6","type":"SecTwo_type__x4CFm","arrow":"SecTwo_arrow__9831D"};